import { render } from "./projectControlMapping.vue?vue&type=template&id=208ce853&scoped=true&ts=true"
import script from "./projectControlMapping.vue?vue&type=script&lang=ts"
export * from "./projectControlMapping.vue?vue&type=script&lang=ts"

import "./projectControlMapping.vue?vue&type=style&index=0&id=208ce853&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-208ce853"]])

export default __exports__